import React from "react";
import { ExtractSwarovskiPageData, ProductListingPageData } from "@swo/storefront";
import { PageMetadataComponent } from "../../components/PageMetadataComponent/PageMetadataComponent";
import { useStore } from "../../store/hooks/use-store";
import { HeaderComponent } from "../../components/HeaderComponent/HeaderComponent";
import { css } from "@emotion/react";
import { ComponentRenderer } from "../_layout-helpers/component-renderer";
import { Spacer } from "../../components/_shared-components/arrangement/Space";
import { ProductListingPageFamiliesCarousel } from "./ProductListingPageFamiliesCarousel/ProductListingPageFamiliesCarousel";
import * as NEA from "fp-ts/es6/NonEmptyArray";
import { option as O } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import { FooterComponent } from "../../components/FooterComponent/FooterComponent";
import { getSwarovskiOptikHeadTitle } from "../_layout-helpers/head-title";
import { ProductListingPageContant } from "./product-listing-page-content";
import { t2 } from "../../domain/translations/translations";

export const ProductListingPageLayout: React.FC<ExtractSwarovskiPageData<ProductListingPageData>> = props => {
  const { locationOrigin } = useStore().state;
  const gt = t2(props.generalTranslations);

  const { metadata } = props.data;
  const currentCategoryId = props.data.productTypes.find(c => c.id === props.page.categoryId);
  const hasMetadata = !!metadata;

  return (
    <>
      {metadata ? (
        <PageMetadataComponent
          {...metadata}
          locationOrigin={locationOrigin}
          languageIsoCode={props.locale.language.isoCode}
        />
      ) : currentCategoryId ? (
        <title>{getSwarovskiOptikHeadTitle(currentCategoryId.name)}</title>
      ) : null}

      <HeaderComponent header={props.data.header} version={"normal"} />

      <ProductListingPageContant {...props} hasMetadata={hasMetadata} />

      {pipe(
        NEA.fromArray(props.data.familiesCarousel),
        O.fold(
          () => null,
          arr => (
            <>
              <Spacer size={"md"} />
              <div
                css={css`
                  max-width: var(--max-container-width);
                  margin: 0 auto;
                  position: relative;
                `}
              >
                <ProductListingPageFamiliesCarousel familiesCarousel={arr} />
              </div>
            </>
          ),
        ),
      )}

      <ComponentRenderer components={props.data.components} localeForNumberFormat={props.locale} translations={gt} />

      <Spacer size={"md"} />
      <FooterComponent {...props.data.footer} />
    </>
  );
};
